import { RefObject } from "react";
import { conformToMask } from "text-mask-core";
import { ConformToMask } from "../mask-input/types";
import { RU_PHONE_CODE, MAX_PHONE_LENGTH } from "./constants";

/**
 * Функция для создания маски
 */
export const createMask: ConformToMask = (...args) => conformToMask(...args);

/**
 * Функция для извлечения чисел телефона из форматированного значения
 *
 * Пример: getRawPhoneValue("+ 7 (900) 111_22_33") -> "79001112233"
 */
export const getRawPhoneValue = (maskedPhoneValue: string) =>
  maskedPhoneValue?.replace(/\D+/g, "");

/**
 * Функция для извлечения чисел номера телефона без кода страны из форматированного значения
 *
 * Пример: getRawPhoneNumberValue("+ 7 (900) 111_22_33") -> "9001112233"
 */
export const getRawPhoneNumberValue = (maskedPhoneValue: string) =>
  maskedPhoneValue?.replace(/(^\+7\s|[\s\D+]*)/g, "");

/**
 * Функция для удаления кода страны из значения
 *
 * Пример: trimPhoneCodeValue("79001112233") -> "9001112233"
 */
export const trimPhoneCodeValue = (rawValue: string) =>
  rawValue.substring(RU_PHONE_CODE.length);

/**
 * Функция для проверки заполненности неформатированного номера телефона
 *
 * Пример: isFilledPhone("79001112233") -> true
 * Пример: isFilledPhone("9001112233") -> false
 */
export const isFilledPhone = (rawPhoneValue: string) =>
  rawPhoneValue?.length >= MAX_PHONE_LENGTH;

/**
 * Функция для установки позиции каретки в поле ввода
 *
 * Пример: setCaretPosition(inputRef, 5)
 */
export const setCaretPosition = (
  inputRef: RefObject<HTMLInputElement>,
  position: number
) => {
  /* Откладываем изменение положения каретки для применения правил форматирования значения маской */
  window.requestAnimationFrame(() => {
    inputRef.current?.setSelectionRange(position, position);
  });
};
